import { render, staticRenderFns } from "./product-excerpt.vue?vue&type=template&id=85793e5c&scoped=true&"
import script from "./product-excerpt.vue?vue&type=script&lang=js&"
export * from "./product-excerpt.vue?vue&type=script&lang=js&"
import style0 from "./product-excerpt.vue?vue&type=style&index=0&id=85793e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85793e5c",
  null
  
)

export default component.exports